import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden border-y border-white/10 py-6 ${className}`} data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span
          key={i}
          className="mx-8 flex items-center gap-16 font-serif text-2xl font-light tracking-wide text-white/30 md:text-3xl"
        >
          {item}
          <span className="text-base text-[#D4AF37]/60">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
